import { useLayoutEffect, useState } from 'react';
import type { ReactElement, ReactNode } from 'react';
import type { Stream } from 'most';

type Props<V> = {
  stream: Pick<Stream<V>, 'subscribe'>;
  children: (value: V) => ReactNode;
};

export function SubscribeStream<V>({
  stream,
  children
}: Props<V>): ReactElement | null {
  const [latestValue, setLatestValue] = useState<V | undefined>(undefined);

  useLayoutEffect(() => {
    const subscription = stream.subscribe({
      // The thunk is what keeps a function value intact: `V` is
      // unconstrained, and a function passed to a setter directly is taken for
      // an updater and called, storing its return value in its place.
      next: (value: V) => setLatestValue(() => value),
      error: () => {},
      complete: () => {}
    });
    return () => subscription.unsubscribe();
  }, [stream]);

  if (typeof latestValue === 'undefined') {
    return null;
  }
  return <>{children(latestValue)}</>;
}
